import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QueueDataService } from '../services/queue-data.service';
import { Queue } from '../models/queue';
import { Connection } from '../models/connection';

@Component({
  selector: 'app-queue',  
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.scss']
})
export class QueueComponent implements OnInit {

  constructor(private dataService: QueueDataService) { }

  ngOnInit(): void {
  }

  private queue: Queue;
  public expandMode: 1;
  public activeOpened: boolean;
  public activeTitle: string;
  public deadLetterOpened: boolean;
  public deadLetterTitle: string;
  public active = false;

  @Input() public connection: Connection;
  @Input() public set model(queue: Queue) {
      this.queue = queue;
      this.active = queue !== undefined;
      this.activeTitle = 'Active Messages: ' + this.queue?.ActiveCount;
      this.deadLetterTitle = 'Dead Letter Messages: ' + this.queue?.DeadLetterCount;
  }
  public get model() {
    return this.queue;
  }

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  public onCancel(e): void {
      e.preventDefault();
      this.closeForm();
  }

  public closeForm(): void {
      this.active = false;
      this.cancel.emit();
  }

  public onDelete(event: any) {
    this.refreshMetaDetails();
  }

  public async onPanelChange(event: any) { 
    var items = event as StateItem[];
    items.forEach(it => {
      if (it.id == "1") {
        this.activeOpened = it.expanded;
      } else if (it.id == "2") {
        this.deadLetterOpened = it.expanded;
      }
    });

    this.refreshMetaDetails();
  }

  private async refreshMetaDetails() {
    this.dataService.getEntities(`$filter=ConnectionId eq ${this.connection.Id} and Name eq '${this.queue.Name}'`)
    .subscribe(r => {
      this.queue = r.value[0];
      this.activeTitle = 'Active Messages: ' + this.queue?.ActiveCount;
      this.deadLetterTitle = 'Dead Letter Messages: ' + this.queue?.DeadLetterCount;
    });    
  }
}

export class StateItem {
  id: string;
  expanded: boolean;
  selected: boolean;
}
